import { render, staticRenderFns } from "./pagesfooter.vue?vue&type=template&id=89714f8e&scoped=true"
import script from "./pagesfooter.vue?vue&type=script&lang=js"
export * from "./pagesfooter.vue?vue&type=script&lang=js"
import style0 from "./pagesfooter.vue?vue&type=style&index=0&id=89714f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89714f8e",
  null
  
)

export default component.exports